module.exports = __webpack_public_path__ + "a166b25325fe6d86438a3fc2320a8307.svg";